import { Button } from '@/components/ui/Button';
import { useUpgradeModalStore } from '@/features/billing/upgradeModalStore';

// Placeholder shown on Settings when the user isn't on the BYO plan. Keeps
// the section slot visible so users know the feature exists, while making
// clear the keys-input is only unlocked by upgrading. Removes the old
// footgun where free users typed an OpenAI key expecting unlimited runs.
export function BYOLockedCard() {
  const openUpgrade = useUpgradeModalStore((s) => s.openModal);
  return (
    <section className="rounded-clyra-lg border border-line-default bg-clyra-raised p-6">
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h2 className="text-sm font-medium text-ink-primary">Your AI keys</h2>
          <p className="mt-1 text-petit text-ink-muted">
            Available on the <strong className="text-ink-secondary">BYO</strong> plan. Bring your
            own OpenAI / Anthropic / Gemini keys and get <strong className="text-ink-secondary">1,000
            generations per account</strong> — the cheapest path if you already pay an AI provider.
          </p>
          <p className="mt-2 text-micro text-ink-faint">
            Keys are stored in your browser only. We never see or transmit them.
          </p>
        </div>
        <Button size="sm" onClick={() => openUpgrade({ defaultPlan: 'byo' })}>
          Go BYO
        </Button>
      </div>
    </section>
  );
}
